import { Navigate } from 'react-router-dom';

import { useAuthContext, useAuthInitializedContext } from '../../hooks/use-user-auth-context.hooks';
import { UserRole } from '../../redux/slice/auth';
import { CustomUser } from '../../redux/slice/auth/CustomUser';
import { CircularLoader } from '../loader/CircularLoader';

export interface OrgAuthenticatedPageProps {
  render: () => JSX.Element;
}
export const OrgAdminAuthenticatedPage: React.FC<OrgAuthenticatedPageProps> = ({
  render,
}: OrgAuthenticatedPageProps) => {
  const user: CustomUser | null = useAuthContext();
  const isAuthenticated: boolean = user ? true : false;
  const isAuthInitialized: boolean = useAuthInitializedContext();
  if (!isAuthInitialized) {
    return (
      <div>
        <CircularLoader />
      </div>
    );
  } else if (!isAuthenticated) {
    return <Navigate to="/login" />;
  } else if (user?.claims.role !== UserRole.ORGANIZATION_ADMIN) {
    return <Navigate to="/dashboard" />;
  } else {
    return render();
  }
};
